module.exports = __webpack_public_path__ + "media/images/fallback/figures/search_thumbnail/default_article_image_2-7b49995bbe691483c00fbd41a9b4b432.png";